import { useMemo } from 'react';
import { bindActionCreators, ActionCreatorsMapObject } from 'redux';
import * as actionList from '~/actions';
import { useDispatch } from './useDispatch';

const useActions = <M extends ActionCreatorsMapObject>(
  getActions: (actions: typeof actionList) => M,
) => {
  const dispatch = useDispatch();

  return useMemo(() => {
    const actions = getActions(actionList);
    return bindActionCreators<M>(actions, dispatch);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [dispatch]);
};

export default useActions;
